// extracted by mini-css-extract-plugin
module.exports = {"resultsinfo":"Calculator_resultsinfo__GunfV","confirmationButtons":"Calculator_confirmationButtons__uRz4j"};